const TIMEZONES = [
  { code: 'UTC -11', format: '-1100' },
  { code: 'UTC -10', format: '-1000' },
  { code: 'UTC -9:30', format: '-0930' },
  { code: 'UTC -7', format: '-0700' },
  { code: 'UTC -6', format: '-0600' },
  { code: 'UTC -4:30', format: '-0430' },
  { code: 'UTC -4', format: '-0400' },
  { code: 'UTC -1', format: '-0100' },
  { code: 'UTC 0', format: '+0000' },
  { code: 'UTC +1', format: '+0100' },
  { code: 'UTC +2', format: '+0200' },
  { code: 'UTC +3', format: '+0300' },
  { code: 'UTC +4', format: '+0400' },
  { code: 'UTC +4:30', format: '+0430' },
  { code: 'UTC +5:30', format: '+0530' },
  { code: 'UTC +5:45', format: '+0545' },
  { code: 'UTC +6', format: '+0600' },
  { code: 'UTC +6:30', format: '+0630' },
  { code: 'UTC +7', format: '+0700' },
  { code: 'UTC +8', format: '+0800' },
  { code: 'UTC +8:45', format: '+0845' },
  { code: 'UTC +9', format: '+0900' },
  { code: 'UTC +9:30', format: '+0930' },
  { code: 'UTC +10', format: '+1000' },
  { code: 'UTC +11', format: '+1100' },
  { code: 'UTC +11:30', format: '+1130' },
  { code: 'UTC +12', format: '+1200' },
  { code: 'UTC +13', format: '+1300' },
  { code: 'UTC +14', format: '+1400' },
];

export default TIMEZONES;
